const escapeHtml = (value) =>
	String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');

export const getRemovedClassMembers = (originalMembers, currentUserIds) => {
	const currentIds = new Set(
		(Array.isArray(currentUserIds) ? currentUserIds : []).map((id) => String(id))
	);

	return (originalMembers || []).filter(
		(member) => !currentIds.has(String(member.value))
	);
};

export const formatRemovedMemberNames = (removedMembers, limit = 5) => {
	const names = removedMembers.map((member) =>
		escapeHtml(member.label || member.value)
	);

	if (names.length <= limit) {
		return names.join(', ');
	}

	return `${names.slice(0, limit).join(', ')}, dan ${names.length - limit} lainnya`;
};

const DETACH_WARNING =
	'Mengeluarkan peserta dari kelas bisa menghapus kehadiran dan riwayat sesi peserta itu. Cara ini bukan untuk memindahkan paket. Untuk pindah paket, buka detail user lalu gunakan Upgrade Membership.';

export const detachClassWarningText = DETACH_WARNING;

export const buildDetachClassConfirm = (removedMembers) => {
	if (!removedMembers.length) {
		return {
			title: 'Apakah Anda yakin?',
			text: 'Anda akan mengubah data peserta kelas',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Ya',
			cancelButtonText: 'Batal',
		};
	}

	const countLabel =
		removedMembers.length === 1
			? '1 peserta'
			: `${removedMembers.length} peserta`;

	return {
		title: 'Keluarkan peserta dari kelas?',
		html: `<p style="text-align:left">${DETACH_WARNING}</p><p style="text-align:left;margin-bottom:0">Yang akan dikeluarkan (${countLabel}): <strong>${formatRemovedMemberNames(removedMembers)}</strong></p>`,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: 'Ya, keluarkan',
		cancelButtonText: 'Batal',
		confirmButtonColor: '#d33',
	};
};
